var _animate, _animate2, _animate3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTapGestureNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\uBD84\\uB9AC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circles"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "circle3",
    style: {
      fill: "#256DE2"
    },
    d: "M325.8,169c-40,0-72.5,32.5-72.5,72.5c0,40,32.5,72.5,72.5,72.5c40,0,72.5-32.5,72.5-72.5             C398.3,201.5,365.8,169,325.8,169z M325.8,331c-49.4,0-89.5-40.2-89.5-89.5c0-49.4,40.2-89.5,89.5-89.5             c49.4,0,89.5,40.2,89.5,89.5C415.3,290.9,375.1,331,325.8,331z"
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    id: "circle3",
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "2.6s;circle2.end",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "circle2",
    style: {
      fill: "#256DE2"
    },
    d: "M325.8,197.6c-24.2,0-43.9,19.7-43.9,43.9c0,24.2,19.7,43.9,43.9,43.9c24.2,0,43.9-19.7,43.9-43.9              C369.6,217.3,350,197.6,325.8,197.6z M325.8,302.4c-33.6,0-60.9-27.3-60.9-60.9c0-33.6,27.3-60.9,60.9-60.9s60.9,27.3,60.9,60.9              C386.6,275.1,359.3,302.4,325.8,302.4z"
  }, _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    id: "circle2",
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "2s;circle1.end",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "circle",
    style: {
      fill: "#256DE2"
    },
    d: "M325.8,226.3c-8.4,0-15.2,6.8-15.2,15.2s6.8,15.2,15.2,15.2s15.2-6.8,15.2-15.2             S334.2,226.3,325.8,226.3z M325.8,273.7c-17.8,0-32.2-14.5-32.2-32.2c0-17.8,14.5-32.2,32.2-32.2c17.8,0,32.2,14.5,32.2,32.2             C358,259.3,343.5,273.7,325.8,273.7z"
  }, _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    id: "circle1",
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "1.4s",
    repeatCount: "indefinite"
  }))))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.6,383.9v27.7c0,0.9-0.1,1.8-0.2,2.6l-19.6,142.6c-2.1,15.2-15.2,26.6-30.5,26.6H343.5c-13.7,0-25.5-8.8-29.5-21.9          l-7.9-26.2c-0.6-2-1.7-3.9-3.2-5.5l-78.1-83.7c-6.4-6-10.2-15-10.2-24.3c0-9.4,3.8-18.2,10.7-24.6c12.4-11.7,32-11.9,45.6-0.6          l25.9,21.4l0-160c0-9.3,3.9-18.2,10.8-24.4c6.9-6.2,16.1-9.3,25.4-8.4c16.7,1.6,29.8,16.5,29.8,33.9v72.3          c5.8-3.3,12.6-4.8,19.4-4.1c11.3,1.1,20.9,8.2,25.9,18c6.6-5,14.9-7.5,23.3-6.7c11.3,1.1,20.9,8.2,25.9,18          c6.6-5,14.9-7.5,23.3-6.6C497.6,351.6,510.6,366.5,510.6,383.9L510.6,383.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M493.8,383.9c0-8.9-6.4-16.4-14.6-17.2c-4.6-0.4-9.1,1-12.5,4.1c-3.4,3.1-5.3,7.4-5.3,12v8.7          c0,4.6-3.8,8.4-8.4,8.4s-8.4-3.8-8.4-8.4v-19.1c0-8.9-6.4-16.4-14.6-17.2c-4.7-0.4-9.1,1-12.5,4.1c-3.4,3.1-5.3,7.4-5.3,12v20.1          c0,4.6-3.8,8.4-8.4,8.4c-4.6,0-8.4-3.8-8.4-8.4v-30.4c0-8.9-6.4-16.4-14.6-17.2c-4.6-0.4-9.1,1-12.5,4.1c-3.4,3.1-5.3,7.4-5.3,12          v31.5c0,4.6-3.8,8.4-8.4,8.4s-8.4-3.8-8.4-8.4l0-132.5c0-8.9-6.4-16.4-14.6-17.2c-4.6-0.5-9.1,1-12.5,4.1c-3.4,3.1-5.3,7.4-5.3,12          v177.9c0,3.3-1.9,6.2-4.8,7.6c-2.9,1.4-6.4,0.9-8.9-1.1l-39.6-32.8c-3.5-2.9-7.9-4.4-12.1-4.4c-4.2,0-8.2,1.4-11.3,4.3          c-3.5,3.3-5.4,7.7-5.4,12.5c0,4.7,1.9,9.1,5.3,12.4l78.5,84.1c3.2,3.4,5.6,7.6,7,12.1l7.9,26.1c1.8,6,7.2,10,13.4,10h116.8          c7,0,12.9-5.2,13.9-12.1L493.8,412L493.8,383.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapGestureNew);
export default __webpack_public_path__ + "static/media/tap_gesture_new.f6189c207463960daf15906798ac7ebb.svg";
export { ForwardRef as ReactComponent };